module.exports = __webpack_public_path__ + "static/media/Icon_logout.e6147fce.svg";